<div class="flex flex-column align-items-center">
    <h2>Panel de administración</h2>
    <div class="flex flex-row gap-3">
        <p-button label="Estadísticas de interacciones" icon="pi pi-chart-bar" (onClick)="goToInteractionsStatistics()"
            class="blue" ariaLabel="Estadísticas de interacciones"></p-button>
        <p-button label="Planes" icon="pi pi-shopping-cart" (onClick)="goToSubscriptions()"></p-button>
    </div>
    <h3 *ngIf="personList.length > 0">{{ personList.length }} perfiles en total</h3>
    <h3 *ngIf="personList.length > 0">{{ visibleProfilesQuantity }} perfiles publicados</h3>
    <p-skeleton *ngIf="personList.length === 0" height="2rem" styleClass="my-3 py-2 w-15rem"></p-skeleton>
    <p-skeleton *ngIf="personList.length === 0" height="100rem" width="20rem" styleClass="my-3 py-2"></p-skeleton>
    <p-table *ngIf="personList.length > 0" #dt1 [value]="personList" [tableStyle]="{'min-width': '5rem'}" dataKey="user.userName" 
        [globalFilterFields]="['name', 'urlId', 'user.userName', 'locality.name', 'idDocument']" [scrollable]="true"
        [paginator]="true" [rows]="15" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="caption">
            <div class="flex flex-row-reverse flex-wrap"        >
                <button pButton label="Quitar filtros" class="p-button-outlined" icon="pi pi-filter-slash" (click)="clear(dt1)"></button>
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt1.filterGlobal($any($event.target).value, 'contains')" placeholder="Buscar" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th class="cabecera">
                    Información
                    <p-columnFilter type="text" field="name" display="menu" matchMode="contains" 
                        [hideOnClear]="true" [showMatchModes]="false" [showOperator]="false" 
                        [showAddButton]="false"></p-columnFilter>
                </th>
                <th class="cabecera">
                    Ubicación
                    <p-columnFilter field="city" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-multiSelect [ngModel]="value" [options]="cities" placeholder="Ciudad" [filter]="false" [showHeader]="false"
                                [showToggleAll]="false" (onChange)="filter($event.value)" optionLabel="name">
                                <ng-template let-option pTemplate="item">
                                    <div class="inline-block vertical-align-middle">
                                        <span class="ml-1 mt-1">{{ option.name }}</span>
                                    </div>
                                </ng-template>
                            </p-multiSelect>
                        </ng-template>
                    </p-columnFilter>
                </th>
                <th class="cabecera">
                    Plan
                    <p-columnFilter field="price" matchMode="equals" display="menu" [showMatchModes]="false" [showOperator]="false" 
                        [showAddButton]="false" [hideOnClear]="true">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-multiSelect [ngModel]="value" [options]="subscriptions" placeholder="Planes" [filter]="false" [showHeader]="false"
                                [showToggleAll]="false" (onChange)="filter($event.value)" optionLabel="name" optionValue="price">
                                <ng-template let-option pTemplate="item">
                                    <div class="inline-block vertical-align-middle">
                                        <span class="ml-1 mt-1">{{ option.name }}</span>
                                    </div>
                                </ng-template>
                            </p-multiSelect>
                        </ng-template>
                    </p-columnFilter>
                </th>
                <th *ngIf="showAll">
                    Características
                </th>
                <th class="cabecera">
                    Acciones
                    <p-columnFilter field="visible" matchMode="equals" display="menu" [showMatchModes]="false" [showOperator]="false" 
                        [showAddButton]="false" [hideOnClear]="true">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-multiSelect [ngModel]="value" [options]="visibilities" placeholder="Visibilidad" [filter]="false" [showHeader]="false"
                                [showToggleAll]="false" (onChange)="filter($event.value)" optionLabel="name" optionValue="value">
                                <ng-template let-option pTemplate="item">
                                    <div class="inline-block vertical-align-middle">
                                        <span class="ml-1 mt-1">{{ option.name }}</span>
                                    </div>
                                </ng-template>
                            </p-multiSelect>
                        </ng-template>
                    </p-columnFilter>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-person>
            <tr>
                <td>
                    <div class="flex flex-row flex-wrap">
                        <p-image src="{{ thumbnailLocation + person.mediaContent[0].fileName }}" height="70px"></p-image> 
                        <div class="flex flex-column flex-wrap m-1" style="max-width: 400px;">
                            <h4 class="m-0 p-0">{{ person.name }}</h4>
                            <p class="m-0 p-0">{{ person.user.userName }}</p>
                            <p class="m-0 p-0">$ {{ person.pricePerHour | number: '1.0-0' : 'co' }}</p>
                            <p class="m-0 p-0">{{ person.schedule }}</p>
                            <p class="m-0 p-0 text-sm"><strong>Fecha de registro:</strong> {{ person.user.registrationDate }}</p>
                            <p class="m-0 p-0 text-sm"><strong>Último ingreso:</strong> {{ person.user.lastLogin }}</p>
                            <!--<div class="py-2" (click)="op2.toggle($event)">-->
                            <div class="py-2">
                                <p class="m-0 p-0 text-sm">Visitas: {{ person.view_quantity }}</p>
                                <p class="m-0 p-0 text-sm">Whatsapp: {{ person.whatsapp_quantity }}</p>
                                <p class="m-0 p-0 text-sm">Llamadas: {{ person.phone_quantity }}</p>
                            </div>
                            <p *ngIf="person.idDocument" class="m-0 p-0"><span class="pi pi-id-card"></span> {{ person.idDocument }}</p>
                            <p *ngIf="person.notes" class="m-0 p-0 font-medium cursor-pointer" (click)="op.toggle($event)">Notas</p>
                            <button pButton class="white" label="Ver perfil" icon="pi pi-external-link" iconPos="right"
                                (click)="goToProfile(person.urlId)"></button>
                        </div>
                    </div>
                    <p-overlayPanel #op styleClass="w-4">
                        <p class="quote">{{ person.notes }}</p>
                    </p-overlayPanel>
                    <!--<p-overlayPanel #op2 styleClass="w-4 overflow-scroll" [style]="{'height': '400px', 'max-height': '500px','width': '400px','max-width': '600px'}">
                        <app-timeline [person]="person"></app-timeline>
                    </p-overlayPanel>-->
                </td>
                <td>{{ person.locality.name }}, {{ person.city.name }}</td>
                <td *ngIf="showAll">
                    Lugares de servicio
                    <ul>
                        <li *ngFor="let servicePlace of person.servicePlaces">{{ servicePlace.description }}</li>
                    </ul>
                    Atributos
                    <ul>
                        <li *ngFor="let service of person.services">{{ service.name }}</li>
                    </ul>
                </td>
                <td>
                    <div class="my-1" *ngIf="!person.subscriptionDetail">
                        <p class="m-0 p-0 text-sm text-red-500">Sin suscripción vigente</p>
                    </div>
                    <div class="my-1" *ngIf="person.subscriptionDetail" 
                        [ngClass]="person.subscriptionDetail.subscription.price === 0 ? 'free-subscription-border' : 'paid-subscription-border'">
                        <p class="m-0 p-0"><strong>Plan:</strong> {{person.subscriptionDetail.subscription.name}}</p>
                        <p class="m-0 p-0 text-sm"><strong>Desde:</strong> {{person.subscriptionDetail.beginDate}}</p>
                        <p class="m-0 p-0 text-sm"><strong>Hasta:</strong> {{person.subscriptionDetail.endDate}}</p>
                    </div>
                </td>
                <td>
                    <div class="flex flex-column gap-2">
                        <button pButton label="Contactar" (click)="contactWhatsapp(person)" icon="pi pi-whatsapp" class="whatsapp"></button>
                        <button pButton label="{{ person.visible === 0 ? 'Mostrar perfil' : 'Ocultar perfil' }}" 
                            icon="{{ person.visible === 0 ? 'pi pi-check' : 'pi pi-times' }}" class="{{ person.visible === 0 ? 'green' : 'red' }}"
                            (click)="setAccessControl('visible', person)" ></button>
                        <p-button label="Más opciones" (onClick)="popupMenu.toggle($event)" styleClass="greyButton" icon="pi pi-ellipsis-v"></p-button>
                    </div>
                    <p-overlayPanel #popupMenu styleClass="transform" [showCloseIcon]="true" [autofocus]="false">
                        <div class="flex flex-column gap-2 w-full m-auto">
                            <button pButton label="{{ person.verified === 0 ? 'Verificar' : 'Quitar verificación' }}" 
                                icon="{{ person.verified === 0 ? 'pi pi-check' : 'pi pi-times' }}" class="{{ person.verified === 0 ? 'yellow' : 'red' }}"
                                (click)="setAccessControl('verified', person)" ></button>
                            <p-button label="Cambiar teléfono" styleClass="w-full greyButton" icon="pi pi-phone" (onClick)="editUsername(person.user.userName, person.urlId)" 
                                ariaLabel="Cambiar teléfono"></p-button>
                            <p-button label="Cambiar contraseña" styleClass="w-full greyButton" icon="pi pi-lock" (onClick)="editPassword(person.user.userName)" 
                                ariaLabel="Cambiar contraseña"></p-button>
                            <p-button label="Editar" icon="pi pi-pencil" (onClick)="editProfile(person.urlId)" 
                                styleClass="w-full greyButton w-full" ariaLabel="Editar información"></p-button>
                            <p-button label="Detalle suscripción" icon="pi pi-tags" (onClick)="goToSubscriptionDetail(person.urlId)" 
                                styleClass="w-full greyButton w-full" ariaLabel="Detalle suscripción"></p-button>
                            <p-button label="Eliminar" icon="pi pi-trash" (onClick)="confirmDelete(person.name, person.urlId, person.user.userName)"
                                styleClass="w-full" ariaLabel="Eliminar perfil"></p-button>
                        </div>
                    </p-overlayPanel>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <p-confirmDialog></p-confirmDialog>
    <app-edit-password [(displayDialog)]="displayPasswordEdit" [userName]="selectedUser">
    </app-edit-password>
    <app-edit-username [displayDialog]="displayUsernameEdit" [userName]="selectedUser" [urlId]="selectedPerson">
    </app-edit-username>

</div>
